<div [formGroup]="form">
  <div
    class="repeatable-card-fields"
    [formGroupName]="i"
    *ngFor="let dt of form?.controls; let i = index">
    <mat-form-field>
      <input
        matInput
        placeholder="Nome scelto (AUTN)"
        formControlName="AUTN">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Dati anagrafici (AUTA)"
        formControlName="AUTA">
    </mat-form-field>
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-icon-button
      type="button"
      (click)="removeAUTHandler(i)">
      <mat-icon name="close">delete</mat-icon>
    </button>
  </div>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addAUTHandler()">
    {{ 'Aggiungi autore' | translate }}
  </button>
</div>
